import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../services/api";

export default function ChangePassword() {

    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const navigate = useNavigate();

    const handleChangePassword = async () => {

        if (!newPassword || !confirmPassword) {

            alert("Please fill all fields.");

            return;

        }

        if (newPassword !== confirmPassword) {

            alert("Passwords do not match.");

            return;

        }

        try {

            await API.post("/auth/change-password", {

                username: localStorage.getItem("username"),

                newPassword

            });

            alert("Password changed successfully.");

            navigate("/dashboard");

        }

        catch (err) {

            if (err.response?.data?.msg) {

                alert(err.response.data.msg);

            }

            else {

                alert("Unable to change password.");

            }

        }

    };

    return (

        <div className="min-h-screen bg-gray-100 flex justify-center items-center">

            <div className="bg-white shadow-xl rounded-xl p-8 w-full max-w-md">

                <h1 className="text-3xl font-bold mb-6">

                    Change Password

                </h1>

                <div className="mb-4">

                    <label className="font-semibold">

                        New Password

                    </label>

                    <input

                        type="password"

                        value={newPassword}

                        onChange={(e) =>
                            setNewPassword(e.target.value)
                        }

                        className="border w-full mt-2 p-3 rounded"

                    />

                </div>

                <div className="mb-6">

                    <label className="font-semibold">

                        Confirm Password

                    </label>

                    <input

                        type="password"

                        value={confirmPassword}

                        onChange={(e) =>
                            setConfirmPassword(e.target.value)
                        }

                        className="border w-full mt-2 p-3 rounded"

                    />

                </div>

                <button

                    onClick={handleChangePassword}

                    className="bg-blue-700 hover:bg-blue-800 text-white w-full py-3 rounded"

                >

                    Change Password

                </button>

            </div>

        </div>

    );

}